export const dictionaryItems = {
    rentAndCharges: "Rent & Charges",
    makeAPayment: "Make a Payment",
    viewTransactionHistory: "View Transaction History",
    repairHistory: "View Repair History",
    bookARepair: "Book a Repair",
    repairsDashboard: "Repairs Dashboard",
    repairs: "Repairs",
    balance: "Balance",
    details: "Details",
    charge: "Charge",
    payment: "Payment",
    makeAPaymentNow: "Make a Payment Now",
    nextDue: "Next Due",
    yourCurrent: "Your Current",
    rentCharge: "Rent Charge",
    to: "To",
    from: "From",
    filter: "Filter",
    showTransactionsFrom: "Show Transactions From",
    days: "Days",
    custom: "Custom",
    downloadTransactions: "Download Transactions",
    currentBalance: "Current Balance",
    inCredit: "In Credit",
    inArrears: "In Arrears",
    viewBalanceBreakdown: "View Balance Breakdown",
    amount: "Amount",
    viewRentBreakdown: "View Rent Breakdown",
    showPaymentsFrom:"Show Payments From"
}
